import React, { useState } from "react";
import { Reveal } from "@/components/Ornaments";
import { Check, Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Rsvp = () => {
  const [name, setName] = useState("");
  const [attendance, setAttendance] = useState("");
  const [guests, setGuests] = useState("1");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !attendance || loading) return;
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/rsvp`, {
        name: name.trim(),
        attendance,
        guests: parseInt(guests, 10) || 1,
      });
      setSubmitted(true);
    } catch (err) {
      setError("დაფიქსირდა შეცდომა. გთხოვთ სცადოთ თავიდან.");
    } finally {
      setLoading(false);
    }
  };

  const options = [
    { key: "yes", label: "დიახ, მოვდივარ" },
    { key: "no", label: "სამწუხაროდ, ვერ მოვდივარ" },
  ];

  return (
    <Reveal>
      <section data-testid="rsvp-form" className="text-center">
        <p className="eyebrow mb-2">R.S.V.P.</p>
        <h2 className="text-xl font-medium tracking-wide text-[#292524] sm:text-2xl">დასწრების დადასტურება</h2>
        <p className="mt-2 text-sm font-light text-[#78716C]">გთხოვთ გვაცნობოთ თქვენი გადაწყვეტილება</p>

        {submitted ? (
          <div data-testid="rsvp-success" className="gold-frame mx-auto mt-7 max-w-sm bg-white px-6 py-8">
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[#E6B7C6] to-[#B0607A] text-white">
              <Check width={22} height={22} />
            </div>
            <p className="font-editorial text-lg italic text-[#1C1917]">გმადლობთ, {name}!</p>
            <p className="mt-1 text-sm text-[#78716C]">თქვენი პასუხი მიიღო.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mx-auto mt-7 max-w-sm space-y-5 text-left">
            <div>
              <label htmlFor="rsvp-name" className="eyebrow mb-1.5 block !text-[10px]">სახელი და გვარი</label>
              <input
                id="rsvp-name"
                data-testid="rsvp-name-input"
                className="input-elegant"
                placeholder="მაგ: ანა ბერიძე"
                maxLength={120}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div>
              <p className="eyebrow mb-1.5 !text-[10px]">დაესწრებით თუ არა?</p>
              <div data-testid="rsvp-attendance" className="grid grid-cols-1 gap-2.5">
                {options.map((o) => (
                  <button
                    key={o.key}
                    type="button"
                    data-testid={`rsvp-attendance-${o.key}`}
                    onClick={() => setAttendance(o.key)}
                    className={`w-full rounded-lg border px-4 py-3 text-left text-sm transition-all duration-200 ${
                      attendance === o.key
                        ? "border-[#C98BA0] bg-[#FDF4F7] text-[#1C1917] shadow-sm"
                        : "border-[#E7E0D0] bg-[#FFFBFC] text-[#57534E] hover:border-[#E0C2CE]"
                    }`}
                  >
                    {o.label}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <label htmlFor="rsvp-guests" className="eyebrow mb-1.5 block !text-[10px]">სტუმრების რაოდენობა</label>
              <select
                id="rsvp-guests"
                data-testid="rsvp-guests-select"
                className="input-elegant appearance-none"
                value={guests}
                onChange={(e) => setGuests(e.target.value)}
              >
                {[1, 2, 3, 4, 5].map((n) => (
                  <option key={n} value={n}>{n} სტუმარი</option>
                ))}
              </select>
            </div>
            {error && (
              <p data-testid="rsvp-error" className="text-center text-sm text-[#B4455A]">{error}</p>
            )}
            <button
              data-testid="rsvp-submit"
              type="submit"
              disabled={loading}
              className="btn-gold flex w-full items-center justify-center gap-2 rounded-full py-3.5 text-sm font-semibold uppercase tracking-[0.15em] disabled:opacity-60"
            >
              {loading && <Loader2 className="animate-spin" width={16} height={16} />}
              {loading ? "იგზავნება..." : "დადასტურება"}
            </button>
          </form>
        )}
      </section>
    </Reveal>
  );
};

export default Rsvp;
